/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1PersonIdSchoolEducationsSchooleducationid202,
  DeleteApiV1PersonIdSchoolEducationsSchooleducationid401,
  DeleteApiV1PersonIdSchoolEducationsSchooleducationid404,
  DeleteApiV1PersonIdSchoolEducationsSchooleducationid500,
  DeleteApiV1PersonIdSchoolEducationsSchooleducationidMutationResponse,
  DeleteApiV1PersonIdSchoolEducationsSchooleducationidPathParams,
} from "../../types/personStudentController/DeleteApiV1PersonIdSchoolEducationsSchooleducationid.ts";

export const deleteApiV1PersonIdSchoolEducationsSchooleducationidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    schoolEducationId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1PersonIdSchoolEducationsSchooleducationidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const deleteApiV1PersonIdSchoolEducationsSchooleducationid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdSchoolEducationsSchooleducationid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1PersonIdSchoolEducationsSchooleducationid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdSchoolEducationsSchooleducationid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1PersonIdSchoolEducationsSchooleducationid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdSchoolEducationsSchooleducationid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1PersonIdSchoolEducationsSchooleducationid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdSchoolEducationsSchooleducationid500>;

export const deleteApiV1PersonIdSchoolEducationsSchooleducationidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1PersonIdSchoolEducationsSchooleducationid202Schema,
  ) as unknown as ToZod<DeleteApiV1PersonIdSchoolEducationsSchooleducationidMutationResponse>;
